import React from 'react'
import './BankDetails.css'

const isBankApproved = (val) =>
    val === 'yes' || val === 'Yes' || val === '1' || val === 1

const BankDetails = ({ transporter_data }) => {
    const bankdetails = transporter_data?.bank_details ?? 'Details not available'
    const hasDetails = bankdetails && bankdetails !== 'Details not available'

    if (hasDetails && isBankApproved(bankdetails.bank_approved)) {
        return (
            <div className="bankdetailscard">
                <div className="bankdetailscontainer">
                    <span className="data_header"><b>Bank Details</b></span>
                    <div className="bankdetailsrow">
                        <div className="bankdetailscolumn">
                            <div className="bankDetails_screen"><b>Bank Approved:</b> Yes</div>
                            <div>
                                <div className="bankDetails_screen">{bankdetails.bank_name && <><b>{bankdetails.bank_name} </b></>}</div>
                                <div className="bankDetails_screen_lower">{bankdetails.iba_registration_number && <><b>Reg No:{bankdetails.iba_registration_number}</b></>}</div>
                            </div>
                        </div>
                        <div className="bankdetailscolumn">
                            <div className="bankDetails_screen">{bankdetails.bank_guarantee && <><b>Bank Guarantee: &#x20b9;</b> {bankdetails.bank_guarantee}</>}</div>
                            <div className="bankDetails_screen">{bankdetails.pan_card && <><b>Pan Card No:</b> {bankdetails.pan_card}</>}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="bankdetailscard">
            <div className="bankdetailscontainer row">
                <div className="col-12">
                    <span className="data_header">Bank Details</span>
                </div>
                {(!hasDetails || !bankdetails.pan_card) ? (
                    <p style={{ marginLeft: '2%' }}>Details not available</p>
                ) : (
                    <div className="col">
                        <div className="bankDetails_screen">{bankdetails.pan_card && <><b>Pan Card No:</b> {bankdetails.pan_card}</>}</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default BankDetails
